import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    esPages: {}
  },
  mutations: {
    esPageAdd: (state, esPage) => {
      state.esPages[esPage.index] = esPage;
    },
    esPageRemove: () => {
    }
  },
  actions: {
    esPageAdd: (context, esPage) => {
      context.commit('esPageAdd', esPage)
    },
    esPageRemove: (context, esPage) => {
      context.commit('esPageRemove', esPage)
    }
  }
});

export default store;
